export default __webpack_public_path__ + "static/image17-2fb11632d4a1611a2560f4f9be8b52bd.jpg";